export default __webpack_public_path__ + "fc089ef65fa4b332e6cefbfcc2deaf9f.svg";